import {exportSvg as Icon__small__exportSvg} from '../Icon__small/Icon__small--export.js';
import {exportSvg as Icon__xsmall__exportSvg} from '../Icon__xsmall/Icon__xsmall--export.js';

export var exportIcon = {
  name: 'export',
  category: 'icon',
  colorable: true,
  svg: Icon__small__exportSvg,
  alt: {
    Icon__small: Icon__small__exportSvg,
    Icon__xsmall: Icon__xsmall__exportSvg,
  },
  combined: ['Icon__small', 'Icon__xsmall'],
};
